/**
 * Build a base64 session id from a user identifier and a timestamp.
 *
 * Uses the date's ISO string (always ASCII) rather than its locale-dependent
 * `toString()` form. On non-English locales `String(new Date())` can contain
 * characters outside the Latin1 range (e.g. the narrow no-break space U+202F
 * French formatting uses), which makes `btoa` throw InvalidCharacterError. When
 * this ran at module top-level it crashed app init before React mounted — a
 * blank white page seen only on non-English-locale devices.
 */
export function buildSessionId(user: string, date: Date = new Date()): string {
    return btoa(user + date.toISOString())
}
